






























































import _ from 'lodash';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

// tslint:disable no-var-requires
const infiniteScroll = require('vue-infinite-scroll');
// tslint:enable no-var-requires

import Product from '@/classes/Product';
import DatePresenter from '@/components/Misc/DatePresenter.vue';
import DollarPresenter from '@/components/Misc/DollarPresenter.vue';
import IdBadge from '@/components/Misc/IdBadge.vue';
import IndexPresenter from '@/components/Misc/IndexPresenter.vue';
import SearchBox from '@/components/Misc/SearchBox.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
// import AddForm from '@/components/Product/AddForm.vue';
import EditForm from '@/components/Product/EditForm.vue';
import { IApiResponseLogin, ITag } from '@/interfaces';
import { upsertList } from '@/main';
import ProductsModule from '@/store/modules/ProductsModule';

const productsModule = getModule(ProductsModule);

export default Vue.extend({
  components: { DatePresenter, DollarPresenter, EditForm, IdBadge, IndexPresenter, SearchBox, TagBadge },
  // components: { AddForm },
  directives: { infiniteScroll },
  data() {
    return {
      IMAGE_BASE_URL: process.env.VUE_APP_IMAGE_BASE_URL,
      busy: false,
      searchBusy: false,
      isAdding: false,
      isEditing: false,
      searchText: '',
      canSearch: false,
      form: {
        editing: {
          originalCopy: new Product(),
        },
      },
    };
  },
  computed: {
    displayProductss(): Product[] {
      if (this.searchText !== '') {
        const products = _.filter(productsModule.products, (product: Product) => {
          const searchText = this.searchText.toLowerCase();
          return product.productid.toLowerCase().includes(searchText)
            || (product.description || '').toLowerCase().includes(searchText)
            || (product.privatenotes || '').toLowerCase().includes(searchText)
            || (product.name || '').toLowerCase().includes(searchText)
            || product.tags.find((tag) => tag.name.toLowerCase().includes(searchText)) !== undefined;
        });
        return products;
      }

      return productsModule.products;
    },
    hasMore(): boolean {
      return productsModule.hasMore;
    },
  },
  methods: {
    loadMore() {
      if (this.searchText === '' && productsModule.hasMore) {
        this.busy = true;

        productsModule.apiLoadNextPage({ pageSize: 5 }).then(() => {
          this.busy = false;
        });
      }
    },
    // addingStart() {
    //   this.isAdding = true;
    // },
    // addingCancelled() {
    //   this.isAdding = false;
    // },
    // addingSaved() {
    //   this.isAdding = false;
    // },
    editingStart(product: Product) {
      this.isEditing = true;
      const productForForm = _.cloneDeep(product);
      productForForm.variances = _.map(productForForm.variances, ($0) => {
        $0.iscreate = false;
        $0.isdelete = false;
        return $0;
      });
      this.form.editing.originalCopy = productForForm;
    },
    editingCancelled() {
      this.isEditing = false;
    },
    editingSaved() {
      this.isEditing = false;
    },
    updateSearchText(searchText: string) {
      this.canSearch = true;
      this.searchText = searchText;
    },
    searchFromServer() {
      this.searchBusy = true;
      productsModule.apiSearchProducts({ searchText: this.searchText }).then(() => {
        this.searchBusy = false;
        this.canSearch = false;
      });
    },
  },
});
